export const choiceChipSizes = ['s', 'm'] as const;
